import { ProcesarDatosApi } from "../api/ApiFetch";
const controlador = "rol";

export const AgregarRol = async (data) => {
    const url = `${controlador}/insertarrol`;
    return await ProcesarDatosApi('POST', url, data);
}

export const ActualizarRol = async (data) => {
    const url = `${controlador}/actualizarrol`;
    return await ProcesarDatosApi('PUT', url, data);
}

export const InactivarRol = async (id) => {
    const url = `${controlador}/eliminarrol?idRol=${id}`;
    return await ProcesarDatosApi('DELETE', url);
}

export const ActualizarPermisos = async (data) => {
    const url = `${controlador}/actualizarpermisos`;
    return await ProcesarDatosApi('PUT', url, data);
}

export const ObtenerRoles = async () => {
    const url = `${controlador}/ObtenerRoles`;
    return await ProcesarDatosApi('GET', url);
}


export const ObtenerRol = async (id) => {
    const url = `${controlador}/ObtenerDetalleRol/${id}`;
    return await ProcesarDatosApi('GET', url);
}

export const ObtenerAccesoMenuPorRol = async (id) => {
    const url = `${controlador}/ObtenerAccesoMenuPorRol/${id}`;
    return await ProcesarDatosApi('GET', url);
}

export const AgregarAccesoMenuPorRol = async (data) => {
    const url = `${controlador}/AgregarAccesoMenuPorRol`;
    return await ProcesarDatosApi('POST', url, data);
}
export const EliminarAccesoMenu = async (id) => {
    const url = `${controlador}/EliminarAccesoMenu?id=${id}`;
    return await ProcesarDatosApi('DELETE', url);
}
export const ObtenerCategoriasMenu = async () => {
    const url = `${controlador}/ObtenerCategoriasMenu`;
    return await ProcesarDatosApi('GET', url);
}

export const ObtenerOpcionesMenuPorCategoria = async (idCategoriaMenu) => {
    const url = `${controlador}/ObtenerOpcionesMenuPorCategoria/${idCategoriaMenu}`;
    return await ProcesarDatosApi('GET', url);
}
